import {
  AlienIcon,
  AppsIcon,
  BarChartIcon,
  BoxAddIcon,
  CheckedCalendarIcon,
  ClockIcon,
  CommentIcon,
  ComputerIcon,
  CrowdIcon,
  GearIcon,
  HouseIcon,
  LogIcon,
  MapIcon,
  PercentIcon,
  RowCellIcon,
  ShopIcon,
  WalletDefaultIcon,
} from '@smartshell/ui-kit';

import { ECountry } from 'settings';

import { getMenuItemsProps, IMenuItem } from './interfaces';

export const getMenuItems: (arg: getMenuItemsProps) => IMenuItem[] = ({
  permissions,
  isBookingAvailable,
  isComboAvailable,
  reviewsCount,
  postPaymentCount,
  isNewsAvailable,
  countryCode,
}) => {
  const menu: IMenuItem[] = [
    {
      to: '/',
      Icon: HouseIcon,
      title: 'nav.dashboard',
    },
  ];

  if (permissions.has('host_browse'))
    menu.push(
      {
        to: '/computers',
        Icon: ComputerIcon,
        title: 'nav.hosts',
      },
      {
        to: '/map',
        Icon: MapIcon,
        title: 'nav.map',
      }
    );

  if (permissions.has('booking_manage'))
    menu.push({
      to: '/bookings',
      Icon: CheckedCalendarIcon,
      title: 'nav.booking',
      featureDisabled: !isBookingAvailable,
    });

  if (permissions.has('payment_create'))
    menu.push({
      to: '/shop',
      Icon: ShopIcon,
      title: 'nav.shop',
    });

  if (permissions.has('work_shift_active') && permissions.has('payment_browse'))
    menu.push({
      to: '/payments',
      Icon: WalletDefaultIcon,
      title: 'nav.payments',
      count: postPaymentCount,
    });

  if (permissions.has('client_browse'))
    menu.push({
      to: '/clients',
      Icon: AlienIcon,
      title: 'nav.clients',
    });

  if (permissions.has('event_browse'))
    menu.push({
      to: '/logs',
      Icon: LogIcon,
      title: 'nav.logs',
    });

  menu[menu.length - 1].showSeparator = true;

  if (permissions.has('shop_manage') && permissions.has('shop_browse'))
    menu.push({
      to: '/shop',
      Icon: BoxAddIcon,
      title: 'nav.shop_manage',
      subItems: [
        {
          to: '/tariffs',
          Icon: ClockIcon,
          title: 'nav.tariffs',
        },
        {
          to: '/goods',
          Icon: ShopIcon,
          title: 'nav.goods',
        },
        {
          to: '/services',
          Icon: ShopIcon,
          title: 'nav.services',
        },
        {
          to: '/combos',
          Icon: ShopIcon,
          title: 'nav.combos',
          featureDisabled: !isComboAvailable,
        },
      ],
    });

  if (
    permissions.has('loyalty_program_manage') &&
    permissions.has('loyalty_program_browse')
  )
    menu.push({
      to: '/loyalty',
      Icon: PercentIcon,
      title: 'nav.loyalty',
      subItems: [
        {
          to: '/discounts',
          Icon: PercentIcon,
          title: 'nav.discounts',
        },
        {
          to: '/promo-codes',
          Icon: PercentIcon,
          title: 'nav.promo',
        },
        {
          to: '/cashback',
          Icon: PercentIcon,
          title: 'nav.cashback',
        },
        {
          to: '/achievements',
          Icon: PercentIcon,
          title: 'nav.achievements',
        },
      ],
    });

  if (permissions.has('worker_manage'))
    menu.push({
      to: '/workers',
      Icon: CrowdIcon,
      title: 'nav.workers',
    });

  if (permissions.has('club_comments_browse'))
    menu.push({
      to: '/reviews',
      Icon: CommentIcon,
      title: 'nav.reviews',
      count: reviewsCount,
    });

  if (
    permissions.has('game_account_manage') &&
    permissions.has('game_account_browse') &&
    permissions.has('shortcut_manage') &&
    permissions.has('shortcut_browse')
  ) {
    menu.push({
      to: '/content',
      Icon: AppsIcon,
      title: 'nav.content',
      subItems: [
        {
          to: '/game-accounts',
          Icon: AppsIcon,
          title: 'nav.gameAccounts',
        },
        {
          to: '/applications',
          Icon: AppsIcon,
          title: 'nav.applications',
        },
        permissions.has('news_manage') && {
          to: '/news',
          Icon: AppsIcon,
          title: 'nav.news',
          featureDisabled: !isNewsAvailable,
        },
      ].filter(Boolean) as IMenuItem[],
    });
  } else if (
    permissions.has('game_account_manage') &&
    permissions.has('game_account_browse')
  ) {
    menu.push({
      to: '/game-accounts',
      Icon: AppsIcon,
      title: 'nav.gameAccounts',
    });
  } else if (
    permissions.has('shortcut_manage') &&
    permissions.has('shortcut_browse')
  ) {
    menu.push({
      to: '/applications',
      Icon: AppsIcon,
      title: 'nav.applications',
    });
  }

  if (permissions.has('reports_manage'))
    menu.push({
      to: '/reports',
      Icon: BarChartIcon,
      title: 'nav.analytics',
    });

  if (countryCode === ECountry.RU)
    menu.push({
      to: '/advertisement',
      Icon: RowCellIcon,
      title: 'nav.advertisement',
      isNew: true,
    });

  if (permissions.has('setting_manage') && permissions.has('setting_browse'))
    menu.push({
      to: '/settings',
      Icon: GearIcon,
      title: 'nav.settings',
    });

  menu[menu.length - 1].showSeparator = false;

  return menu;
};
